import { FC, useState } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { useIwExecutionStore } from '@/entities/interwills';
import { useScenariosActions } from '@/entities/scenarios';
import { useNotices } from '@/features/notices/useNotices';
import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { ScenarioDeleteModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

export const ScenarioDeleteModal: FC<ScenarioDeleteModalProps> = () => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'scenarioDelete' });
  const modals = useModalsStore();
  const notices = useNotices();
  const { scenarioSettings, setScenarioSettings } = useIwExecutionStore();
  const [loading, setLoading] = useState(false);

  const { deactivateScenario, deleteScenario } = useScenariosActions();

  const onClick = async () => {
    setLoading(true);
    if (scenarioSettings?.id) {
      await deactivateScenario(scenarioSettings?.id);
      await deleteScenario(scenarioSettings?.id);
    }
    notices.success(t('deletedMsg'));
    setScenarioSettings(null);
    modals.closeModal();
    setLoading(false);
  };

  return (
    <ModalContainerV2 pinBottom title={t('title')}>
      <InnerForm>
        <span>{t('text')}</span>
      </InnerForm>
      <Buttons>
        <ButtonIw onClick={modals.closeModal} type="default">
          {t('cancelBtn')}
        </ButtonIw>
        <ButtonIwStyled onClick={onClick} loading={loading} disabled={loading}>
          {t('confirmBtn')}
        </ButtonIwStyled>
      </Buttons>
    </ModalContainerV2>
  );
};

const InnerForm = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 24px 0;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;

  ${media.iwMobile} {
    flex-direction: column-reverse;
  }
`;

const ButtonIwStyled = styled(ButtonIw)`
  && {
    background: ${COLORS.systemFlame200};
    &&:hover {
      background: ${COLORS.systemFlame300};
    }
  }
`;
